<template>
  <el-main>
    <div class="container">
      <el-breadcrumb separator="/" class="common-nav">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>资讯</el-breadcrumb-item>
      </el-breadcrumb>
      <el-row :gutter="20">
        <el-col :span="4">
          <div class="news-item column">
            <router-link :to="{path: '/news'}" class="column-item" :active-class="column">
              全部资讯
            </router-link>
            <router-link class="column-item" v-for="(item, index) in columns" :key="index"
                         :to="{path: '/news', query: {id: item.id}}"
                         :active-class="column">
              {{ item.title }}
            </router-link>
          </div>
        </el-col>
        <el-col class="" :span="12">
          <div class="news-item list">
            <el-row :gutter="10" class="list-item" v-for="(item, index) in news" :key="index">
              <el-col :span="5" v-if="item.image">
                <router-link :to="{path: '/news/details', query: {id: item.id}}">
                  <el-image :src="path + item.image" fit="cover" class="list-image"></el-image>
                </router-link>
              </el-col>
              <el-col :span="item.image ? 19 : 24">
                <div class="list-info">
                  <router-link class="list-info-title" :to="{path: '/news/details', query: {id: item.id}}">{{
                      item.title
                    }}
                  </router-link>
                  <div class="list-info-intro" v-html="item.intro"></div>
                  <div class="list-info-time">
                    <i class="el-icon-time"></i>
                    <span>{{ item.created_at }}</span>
                  </div>
                </div>
              </el-col>
            </el-row>
            <div class="list-pagination">
              <el-pagination
                  background
                  layout="prev, pager, next"
                  @current-change="handleCurrentChange"
                  :page-size="page_meta.per_page"
                  :total="page_meta.total">
              </el-pagination>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <el-card class="box-card">
            <div slot="header" class="hot-title">
              <i class="el-icon-star-on"></i>
              <span> 热门推荐</span>
            </div>
            <router-link :to="{path: '/news/details', query: {id: item.id}}" v-for="(item, index) in hot" :key="index"
                         class="hot-item">
              {{ item.title }}
            </router-link>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </el-main>
</template>

<script>
import {request} from "@/utils/request";

export default {
  name: "Index",
  head: {
    title: "资讯"
  },
  data() {
    return {
      id: 1,
      columns: [],
      news: [],
      path: process.env.VUE_APP_FILE,
      page: 1,
      column: '',
      page_meta: [],
      hot: []
    }
  },
  created() {
    this.column = this.$route.query.id ? String(this.$route.query.id) : ''
    this.getColumn()
    this.getNews()
    this.getHot()
  },
  watch: {
    '$route': 'fetchData'
  },
  methods: {
    async getColumn() {
      try {
        let response = await request('news/column', {
          method: 'GET'
        })
        this.columns = response.data
      } catch (e) {

      }
    },
    async getNews() {
      try {
        let response = await request('news', {
          method: 'GET',
          params: {
            page: this.page,
            'filter[news_column_id]': this.column
          }
        })
        let news = response.data
        this.news = news.data
        this.page_meta = news.meta
      } catch (e) {

      }
    },
    async getHot() {
      try {
        let response = await request('news/hot', {
          method: 'POST',
          data: {
            limit: 10,
          }
        })
        this.hot = response.data.data
      } catch (e) {

      }
    },
    handleCurrentChange(val) {
      this.page = val
      this.getNews()
    },
    fetchData(e) {
      let column = e.query.id ? e.query.id : ''
      this.column = String(column)
      this.page = 1
      this.getNews()
    }
  }
}
</script>

<style scoped>
.news-item {
  background-color: #ffffff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  box-sizing: border-box;
  padding: 10px 0;
}

.column-item {
  text-align: center;
  line-height: 40px;
  color: #606266;
  cursor: pointer;
  font-size: 15px;
  display: block;
}

.column-item:hover, .column-item:focus {
  background-color: #eaf7f7;
  color: #55bdc1;
}

.column-item.router-link-exact-active {
  border-left: 3px solid #2aacb2;
  color: #2aacb2;
}

.list {
  padding-left: 10px;
  padding-right: 10px;
}

.hot-title {
  color: #2aacb2;
  font-weight: bold;
}

.list-image {
  border-radius: 4px;
  height: 80px
}

.list-item {
  border-bottom: 1px solid #EBEEF5;
  padding: 10px 0;
}

.list-info-title {
  font-size: 15px;
  color: #404040;
}

.list-info-intro {
  font-size: 12px;
  color: #999999;
}

.list-info-time {
  margin-top: 5px;
  color: #999999;
  font-size: 12px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.list-info-time .el-icon-time {
  margin-right: 5px;
}

.list-pagination {
  margin: 25px 0 20px;
  text-align: center;
}

.hot-item {
  font-size: 14px;
  color: #404040;
  margin-bottom: 8px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
}

.hot-item:hover, .hot-item:focus {
  color: #2aacb2;
}
</style>